(() => {
  const formatCountryKey = (code) => code.trim().toLowerCase();

  const getGeo = async () => {
    if (window.wigiwama?.geolocation?.countryCode) {
      return window.wigiwama.geolocation;
    }

    try {
      return await window.wigiwama?.functions?.queryLocale();
    } catch (error) {
      console.warn('Trust indicator locale detection failed', error);
      return null;
    }
  };

  const updateElement = (el, geo) => {
    const items = el.querySelectorAll('[data-js-trust-country]');

    items.forEach((item) => {
      item.classList.remove('trust-indicator__text--visible');
    });

    el.classList.add('trust-indicator--loading');
    el.classList.remove('trust-indicator--ready');
    el.classList.remove('trust-indicator--hidden');

    const countryCode = geo?.countryCode;
    const key = countryCode ? formatCountryKey(countryCode) : null;
    const matched = key ? el.querySelector(`[data-js-trust-country="${key}"]`) : null;

    console.log('[Trust Indicator]', {
      detectedCountryCode: key,
      detectedCountryName: geo?.countryName || null,
      availableCountries: [...items].map((item) => item.getAttribute('data-js-trust-country')),
      matched: Boolean(matched),
    });

    if (!matched) {
      el.classList.remove('trust-indicator--loading');
      el.classList.add('trust-indicator--hidden');
      el.setAttribute('state', 'ready');
      return;
    }

    matched.classList.add('trust-indicator__text--visible');
    el.classList.remove('trust-indicator--loading');
    el.classList.add('trust-indicator--ready');
    el.setAttribute('state', 'ready');
  };

  const init = async () => {
    const elements = document.querySelectorAll('[js-trust-indicator]');
    if (!elements.length) return;

    const geo = await getGeo();
    elements.forEach((el) => updateElement(el, geo));
  };

  init();

  document.addEventListener('shopify:section:load', (event) => {
    const elements = event.target.querySelectorAll('[js-trust-indicator]');
    if (!elements.length) return;

    getGeo().then((geo) => {
      elements.forEach((el) => updateElement(el, geo));
    });
  });
})();
